module.exports = __webpack_public_path__ + "static/media/no-data.a704dfe6.svg";